import { SubmissionError } from "redux-form";
import { authConstants } from "../../../../constants/authenticationConstants";
import { authHeader, handleResponse, handleError } from "../../../../helpers";
import { push } from "react-router-redux";
import { notify } from '../../../../helpers/notification';
import { config } from "../../../../helpers/config";
import i18n from "../../../../i18n"; // Import i18n directly

const loginMiddleware = async (values, dispatch) => {
    if (values.email !== undefined && values.password !== undefined) {
        dispatch({ type: authConstants.LOGIN_BEGIN });
        const loginUrl = `${config.base}api/Authentication/Login`;
        const user = {
            email: values.email.trim(),
            password: values.password,
            type: values.loginType,
        };

        return fetch(loginUrl, {
            method: "POST",
            headers: {
                ...authHeader(), // Include existing headers
                "Accept-Language": i18n.language, // Add language header
                "Content-Type": "application/json", // Ensure JSON content type
            },
            body: JSON.stringify(user),
        })
            .then(handleResponse)
            .then((loggedUser) => {
                localStorage.setItem("loggedUser", JSON.stringify(loggedUser));
                return loggedUser;
            })
            .then(
                (loggedUser) => {
                    dispatch({
                        type: authConstants.LOGIN_SUCCESS,
                        loggedUser,
                    });
                    if (values.loginType === "admin") {
                        dispatch(push("/"));
                    } else if (
                        values.loginType === "student" &&
                        !loggedUser.isActivated
                    ) {
                        dispatch(push("/student/profile"));
                    }
                    dispatch(
                        notify({
                            message: i18n.t("loginSuccess"), // Translated message
                            status: 200,
                        })
                    );
                },
                (error) => {
                    dispatch({
                        type: authConstants.LOGIN_ERROR,
                        error,
                    });
                    dispatch(
                        notify({
                            message: error,
                            status: 400,
                        })
                    );
                    throw new SubmissionError({
                        password: i18n.t("loginFailed"), // Translated message
                        _error: i18n.t("wrongPassword"), // Translated message
                    });
                }
            );
    }
};

export default loginMiddleware; // No need for withTranslation


//import { SubmissionError } from "redux-form";
//import { authConstants } from "../../../../constants/authenticationConstants";
//import { authHeader, handleResponse, handleError } from "../../../../helpers";
//import { push } from "react-router-redux";
//import { notify } from '../../../../helpers/notification';
//import { config } from "../../../../helpers/config";
//import i18n from "../../../../i18n"; // Import i18n directly

//const loginMiddleware = async (values, dispatch, { t }) => {
//    if (values.email !== undefined && values.password !== undefined) {
//        dispatch({ type: authConstants.LOGIN_BEGIN });
//        const loginUrl = `${config.base}api/Authentication/Login`;
//        const user = {
//            email: values.email.trim(),
//            password: values.password,
//            type: values.loginType,
//        };

//        return fetch(loginUrl, {
//            method: "POST",
//            headers: {
//                ...authHeader(), // Include existing headers
//                "Accept-Language": i18n.language, // Add language header
//                "Content-Type": "application/json", // Ensure JSON content type
//            },
//            body: JSON.stringify(user),
//        })
//            .then(handleResponse)
//            .then((loggedUser) => {
//                localStorage.setItem("loggedUser", JSON.stringify(loggedUser));
//                return loggedUser;
//            })
//            .then(
//                (loggedUser) => {
//                    dispatch({
//                        type: authConstants.LOGIN_SUCCESS,
//                        loggedUser,
//                    });
//                    if (values.loginType === "admin") {
//                        dispatch(push("/"));
//                    } else if (
//                        values.loginType === "student" &&
//                        !loggedUser.isActivated
//                    ) {
//                        dispatch(push("/student/profile"));
//                    }
//                    dispatch(
//                        notify({
//                            message: t("loginSuccess"), // Translated message
//                            status: 200,
//                        })
//                    );
//                },
//                (error) => {
//                    dispatch({
//                        type: authConstants.LOGIN_ERROR,
//                        error,
//                    });
//                    dispatch(
//                        notify({
//                            message: error,
//                            status: 400,
//                        })
//                    );
//                    throw new SubmissionError({
//                        password: t("loginFailed"), // Translated message
//                        _error: t("wrongPassword"), // Translated message
//                    });
//                }
//            );
//    }
//};

//export default loginMiddleware; // No need for withTranslation


//import { SubmissionError } from "redux-form";
//import { authConstants } from "../../../../constants/authenticationConstants";
//import { authHeader, handleResponse, handleError } from "../../../../helpers";
//import { push } from "react-router-redux";
//import { notify } from '../../../../helpers/notification';
//import { config } from "../../../../helpers/config";
//import { withTranslation } from 'react-i18next'; // Import withTranslation
//import i18n from "../../../../i18n"; // Adjust the path to your i18n setup

//const loginMiddleware = async (values, dispatch, { t }) => { // Destructure t from props
//    if (values.email !== undefined && values.password !== undefined) {
//        dispatch({ type: authConstants.LOGIN_BEGIN });
//        const loginUrl = `${config.base}api/Authentication/Login`;
//        const user = {
//            email: values.email.trim(),
//            password: values.password,
//            type: values.loginType
//        };
//        return fetch(loginUrl, {
//            method: "POST",
//            headers: {
//            ...authHeader(), // Include existing headers
//              "Accept-Language": i18n.language, // Add language header                
//        },
//            body: JSON.stringify(user)
//        })
//            .then(handleResponse)
//            .then(loggedUser => {
//                localStorage.setItem("loggedUser", JSON.stringify(loggedUser));
//                return loggedUser;
//            })
//            .then(
//                loggedUser => {
//                    dispatch({
//                        type: authConstants.LOGIN_SUCCESS,
//                        loggedUser
//                    });
//                    if (values.loginType === "admin") {
//                        dispatch(push("/"));
//                    } else if (
//                        values.loginType === "student" &&
//                        !loggedUser.isActivated
//                    ) {
//                        dispatch(push("/student/profile"));
//                    }
//                    dispatch(
//                        notify({
//                            message: t("loginSuccess"), // Translated message
//                            status: 200
//                        })
//                    );
//                },
//                error => {
//                    dispatch({
//                        type: authConstants.LOGIN_ERROR,
//                        error
//                    });
//                    dispatch(
//                        notify({
//                            message: error,
//                            status: 400
//                        })
//                    );
//                    throw new SubmissionError({
//                        password: t("loginFailed"), // Translated message
//                        _error: t("wrongPassword") // Translated message
//                    });
//                }
//            );
//    }
//};

//export default withTranslation()(loginMiddleware); // Wrap with withTranslation

//import { SubmissionError } from "redux-form";
//import { authConstants } from "../../../../constants/authenticationConstants";
//import { authHeader, handleResponse, handleError} from "../../../../helpers";
//import { push } from "react-router-redux";
//import {notify} from '../../../../helpers/notification';
//import { config } from "../../../../helpers/config";
//import i18n from "../../../../i18n"; // Adjust the path to your i18n setup

////const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

//const loginMiddleware = async (values, dispatch) => {
//    if (values.email !== undefined && values.password !== undefined) {
//        dispatch({ type: authConstants.LOGIN_BEGIN });
//        const loginUrl = `${config.base}api/Authentication/Login`;
//        const user = {
//            email: values.email.trim(),
//            password: values.password,
//            type: values.loginType
//        };        

//        return fetch(loginUrl, {
//            method: "POST",
//            headers: {
//                ...authHeader(), // Include existing headers
//                "Accept-Language": i18n.language, // Add language header                
//            },
//            body: JSON.stringify(user)
//		})
//			.then(handleResponse)
//            .then(loggedUser => {
//                localStorage.setItem("loggedUser", JSON.stringify(loggedUser));
//                return loggedUser;
//            })
//            .then(
//                loggedUser => {
//                    dispatch({
//                        type: authConstants.LOGIN_SUCCESS,
//                        loggedUser
//                    });
//                    if (values.loginType === "admin") {
//                        dispatch(push("/"));
//                    } else if (
//                        values.loginType === "student" &&
//                        !loggedUser.isActivated
//                    ) {
//                        dispatch(push("/student/profile"));
//                    }
//                    dispatch(
//                        notify({
//                            message: "Успешен вход!",
//                            status: 200
//                        })
//                    );
//                },
//                error => {

//                    dispatch({
//                        type: authConstants.LOGIN_ERROR,
//                        error
//                    });
//                    dispatch(
//                        notify({
//                            message: error,
//                            status: 400
//                        })
//                    );
//                    throw new SubmissionError({
//                        password: "Неуспешен вход",
//                        _error: "Wrong password!"
//                    });
//                }
//            );
//    }
//};

//export default loginMiddleware;
